import { REVIEWS_MIN_COUNT, REVIEWS_PAGE_SIZE } from 'constants/reviews';

import type { TReview } from 'shared/types/TReviewsService';

export const decorateReviews = (items: TReview[] | null): TReview[] => {
  const ids: string[] = [];
  const reviews = (items || []).reduce((output: TReview[], item: TReview) => {
    if (item.alias || item.organizationName) {
      if (ids.every((elem) => elem !== item.reviewObjectId) && item.reviewObjectId) {
        ids.push(item.reviewObjectId);
        output.push(item);
      }
    }

    return output.length > REVIEWS_PAGE_SIZE ? output.slice(0, REVIEWS_PAGE_SIZE) : output;
  }, []);

  return reviews.length > REVIEWS_MIN_COUNT ? reviews : [];
};
